import { supabase } from '@/services/supabase';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/logout')({
  component: RouteComponent,
  beforeLoad: async () => {
    await supabase.auth.signOut({ scope: 'local' });

    throw redirect({ to: '/login', replace: true });
  },
});

function RouteComponent() {
  return null;
}
